import React from 'react'
import { getLoginInfo } from '../auth/getLoginInfo';
import { createAxios, createAxiosWithToken } from './createAxios';
import { getAuth } from '../auth/publicUsers/authStorage';

export async function GoogleOAuth(param) {
    return await createAxios().post("/PublicUser/GoogleOAuth?Token=" + param.token)
}
export async function GoogleOAuthPublicUserCreate(param) {
    return await createAxios().post("/PublicUser/GoogleOAuthPublicUserCreate?Token=" + param.token + "&PhoneNo=" + param.phoneNo)
}
export async function IsUser(param) {
    return await createAxios().post("/PublicUser/IsUser?Email=" + param.email)
}
export async function GetAllConfirmed(param) {
    let loginData = getAuth();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/PublicUser/GetAllConfirmed?PageNo=" + param.PageNo + "&PageSize=" + param.PageSize + "&SearchTerm=" + param.SearchTerm + "&PhoneNo=" + param.PhoneNo)
}
export async function GetAllRegistered(param) {
    let loginData = getAuth();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/PublicUser/GetAllRegistered?PageNo=" + param.PageNo + "&PageSize=" + param.PageSize + "&SearchTerm=" + param.SearchTerm + "&PhoneNo=" + param.PhoneNo)
}


